import { createSVGWrapper } from "./SVGWrapper";

/**
 * @deprecated This icon is deprecated. Please use Lucide React icons instead.
 * @see https://lucide.dev/ for available icons
 * @example
 * import { Users } from "lucide-react";
 * // Use <Users /> instead
 */
export const CustomersIcon = createSVGWrapper(
  <path
    fill="currentColor"
    d="M5 5.5a3.5 3.5 0 0 1 6.826-1.093A5.486 5.486 0 0 0 10 8.5v1c0 .054 0 .108.002.162A3.5 3.5 0 0 1 5 6.5v-1ZM10.437 11.652a10 10 0 0 0-4.878.253l-.104.032a4 4 0 0 0-2.746 4.607l.13.652a1 1 0 0 0 .98.804h3.86a6.004 6.004 0 0 1 3.737-4.816 5.505 5.505 0 0 1-.979-1.532ZM12 8.5a3.5 3.5 0 1 1 7 0v1a3.5 3.5 0 1 1-7 0v-1ZM9.709 19.544a4 4 0 0 1 2.746-4.607l.104-.032a9.999 9.999 0 0 1 5.882 0l.104.032a4 4 0 0 1 2.746 4.607l-.13.652a1 1 0 0 1-.98.804H10.82a1 1 0 0 1-.98-.804l-.131-.652Z"
  />
);
